import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, LogIn, FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="flex min-h-[80vh] items-center justify-center p-4">
      <div className="w-full max-w-md overflow-hidden rounded-3xl border border-gray-100 bg-white p-8 text-center shadow-2xl transition-all animate-in zoom-in-95 duration-300">
        
        {/* Animated icon */}
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-50 text-gray-500 shadow-inner">
          <FileQuestion className="h-8 w-8 animate-pulse" />
        </div>

        <h2 className="mt-6 text-2xl font-black tracking-tight text-gray-900">
          Página não encontrada
        </h2>
        
        <p className="mt-3 text-sm font-medium leading-relaxed text-gray-500">
          A página que você tentou acessar não existe, foi movida ou a URL foi digitada incorretamente.
        </p>

        <div className="mt-8 flex flex-col gap-3">
          {user ? (
            <Button
              onClick={() => navigate("/dashboard")}
              className="w-full h-11 bg-primary hover:bg-primary/95 text-white font-bold rounded-xl text-xs flex items-center justify-center gap-2 shadow-md transition-all"
            >
              <LayoutDashboard className="w-4 h-4" />
              Voltar ao Dashboard
            </Button>
          ) : (
            <Button
              onClick={() => navigate("/auth")}
              className="w-full h-11 bg-primary hover:bg-primary/95 text-white font-bold rounded-xl text-xs flex items-center justify-center gap-2 shadow-md transition-all"
            >
              <LogIn className="w-4 h-4" />
              Ir para Login
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
